module.exports = __webpack_public_path__ + "img/teeth-25.a6bb80c6.png";